/** Compact well create pair: [entry_date ISO, well_name] (legacy) */
export type WellCreatePair = [string, string];

/** Create well with optional MB fields written in the same bulk request */
export type WellCreateItem = {
  entry_date: string;
  well_name: string;
  x_km?: number | null;
  y_km?: number | null;
  ini_liquid?: number | null;
  end_year?: number | null;
};

export type WellCreateEntry = WellCreatePair | WellCreateItem;

export type ScenarioWellLayerCreateBatch = {
  production: WellCreateEntry[];
  injection: WellCreateEntry[];
};

export function createEmptyLayerCreateBatch(): ScenarioWellLayerCreateBatch {
  return { production: [], injection: [] };
}

export function countGroupedWellsCreate(
  grouped: Record<string, ScenarioWellLayerCreateBatch>,
): number {
  return Object.values(grouped).reduce(
    (total, batch) => total + batch.production.length + batch.injection.length,
    0,
  );
}

export function ensureLayerCreateBatch(
  grouped: Record<string, ScenarioWellLayerCreateBatch>,
  layerId: string,
): ScenarioWellLayerCreateBatch {
  if (!grouped[layerId]) {
    grouped[layerId] = createEmptyLayerCreateBatch();
  }
  return grouped[layerId];
}
